import { Component, OnInit } from '@angular/core';
import { ListService, PagedResultDto } from '@abp/ng.core';
import { Column } from '../shared/components/metro-table/metro-table.component';
import { GetPickUpDto, PickUpDto } from '../proxy/pick-ups/models';
import { PickUpService } from '../proxy/pick-ups/pick-up.service';
import { Router } from '@angular/router';

import { APP_ICONS } from '../shared/icons/app-icons';
import { finalize, take } from 'rxjs';

interface FormattedPickUpDto extends PickUpDto {
  // No need to omit any fields for formatting
}

@Component({
  selector: 'app-pickuppoints',
  templateUrl: './pickuppoints.component.html',
  providers: [ListService],
  standalone: false,
})
export class PickupPointsComponent implements OnInit {
  columns: Column[] = [
    // winepassport#379 — anchos rebalanceados a ~100% (antes ~115% y la tabla "hacía zoom").
    // Se saca `colppyWarehouseName` de la grilla (redundante con `name`; sigue en el form/Excel)
    // y `email` (queda en el form). Se agrega `city` (Localidad).
    // winepassport#385 — "Id" wrappeaba y duplicaba la altura de fila. +2% sacado de "Dirección".
    { name: 'id', label: '::Id', width: '8%', textColor: 'text-metro-blue-secondary', noWrap: true },
    { name: 'name', label: '::Name', width: '20%', textColor: 'text-metro-blue-secondary' },
    { name: 'address', label: '::Address', width: '20%', textColor: 'text-metro-blue-secondary' },
    { name: 'province', label: '::Province', width: '14%', textColor: 'text-metro-blue-secondary' },
    { name: 'city', label: '::City', width: '14%', textColor: 'text-metro-blue-secondary' },
    { name: 'isActive', label: '::IsActive', width: '12%', textColor: 'text-metro-blue-secondary', type: 'status' },
    { name: 'isVisible', label: '::IsVisible', width: '12%', type: 'status' },
  ];

  actions: any[] = [
    // { name: 'view', label: '::View', handler: (row: FormattedPickUpDto) => this.viewPickUp(row) },
    { name: 'edit', label: '::Edit', handler: (row: FormattedPickUpDto) => this.openEditModal(row) },
  ];

  openCreateModal() {
    this.router.navigate(['/backoffice/pickuppoints/create']);
  }

  openEditModal(pickup: FormattedPickUpDto) {
    this.router.navigate(['/backoffice/pickuppoints/edit', pickup.id]);
  }

  data: PagedResultDto<FormattedPickUpDto> = { items: [], totalCount: 0 };
  searchPickUp = {} as GetPickUpDto;
  isLoading = true;
  isExporting = false;
  excelIcon = APP_ICONS.excel;

  constructor(
    public readonly list: ListService,
    private pickUpService: PickUpService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const streamCreator = (query) =>
      this.pickUpService.getList({ ...this.searchPickUp, ...query });

    this.list.hookToQuery(streamCreator).subscribe((result) => {
      this.data = result;
      this.isLoading = false;
    });
  }

  onSearch(searchTerm: string) {
    this.isLoading = true;
    this.searchPickUp.keyword = searchTerm;
    this.list.page = 0;
    this.list.get();
  }

  onClearSearch() {
    this.isLoading = true;
    this.searchPickUp = {} as GetPickUpDto;
    this.list.page = 0;
    this.list.get();
  }

  onPageChange(page: number) {
    this.isLoading = true;
    this.list.page = page - 1;
    this.list.get();
  }

  generateExcel() {
    this.isExporting = true;

    this.pickUpService.generateExcel({ responseType: 'blob' } as any)
      .pipe(
        take(1),
        finalize(() => this.isExporting = false)
      )
      .subscribe({
        next: (blob) => {
          const fileName = 'PuntosDeRetiro.xlsx';
          const downloadUrl = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = fileName;
          link.click();

          window.URL.revokeObjectURL(downloadUrl);
        },
        error: (err) => {
          console.error('Error al generar Excel de puntos de retiro', err);
        }
      });
  }
}
